export const rowsPerPageOptions = [5, 10, 25];

export const userColumns = [
  { id: "user_name", label: "User Name" },
  { id: "email", label: "Email" },
  { id: "user_role", label: "Role" },
];
